/**
 * 随管家客户端相关处理
 * 说明：处理随管家客户端内相关协议，包括以下功能【更新后请依次填写】
 * 1、获取随管家客户端设备号
 */

import clientBridge from '@common/client/src/bridge'

const CLIENTINFO_URI = 'sgj://api/getClientInfo' // 获取设备信息协议链接

// 获取设备信息
const getClientInfo = () => {
  return new Promise((resolve, reject) => {
    clientBridge.call(clientBridge.uriSuiguanjia(CLIENTINFO_URI, {}, 'onClientInfoResult'), 'onClientInfoResult', (result) => {
      console.log('Collect Suiguanjia Data:', result)
      if (result.code === '000000') {
        resolve(result)
      } else {
        reject(result.msg)
      }
    })
  })
}

class SuiguanjiaClient {
  static clientInfo = null
  async getClientInfo() {
    if (!this.clientInfo) {
      try {
        const result = await getClientInfo()
        this.clientInfo = result.data
      } catch (error) {
        console.warn('Collect Suiguanjia Error:', error)
      }
    }
    return {
      appName: 'Suiguanjia',
      appVersion: this.clientInfo ? this.clientInfo.version : '',
      channel: this.clientInfo ? this.clientInfo.channel : '',
      udid: this.clientInfo ? this.clientInfo.udid : '',
    }
  }
}

export default SuiguanjiaClient


// WEBPACK FOOTER //
// ./node_modules/@common/collect/src/client/suiguanjia.js